import { dataCheckCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCheckCircleSolid = /*#__PURE__*/createIcon(dataCheckCircleSolid)
export default IconCheckCircleSolid
